import { render, staticRenderFns } from "./HomePopup.vue?vue&type=template&id=4056ee2a"
import script from "./HomePopup.vue?vue&type=script&lang=js"
export * from "./HomePopup.vue?vue&type=script&lang=js"
import style0 from "./HomePopup.vue?vue&type=style&index=0&id=4056ee2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports